import { takeLatest, put, call } from "redux-saga/effects";

import {
  GET_JUNIOR_HANDLING_RESULT_FILES,
  ADD_JUNIOR_HANDLING_EVENT_FILE,
  DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE,
  GET_JUNIOR_HANDLING_FILE_RESULTS,
  GET_JUNIOR_EVENT_ATTENDEE_RESULTS
} from "./actionTypes";

import {
  getJuniorHandlingEventsSuccess,
  getJuniorHandlingEventsFail,
  delJuniorHandlingEventFileSuccess,
  delJuniorHandlingEventFileFailure,
  addJuniorHandlingEventSuccess,
  addJuniorHandlingEventFailure,
  getJuniorHandlingFileResultsFail,
  getJuniorHandlingFileResultsSuccess,
  getJuniorHandlingAttendeeResultsSuccess,
  getJuniorHandlingAttendeeResultsFail,

} from "./actions";

import {

  addJuniorHandlingEventResultDisplay,

  delJuniorHandlingEventDisplayFile,
  getJuniorHandlingFileResults,
  getJuniorHandlingFileResultsAttendeesList,
  getJuniorHandlingResultsDisplayFiles,

} from "../../helpers/backend_helper";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// junior halding file result
function* onGetJuniorHandlingFileResults({ payload: data, token }) {


  try {
    const response = yield call(getJuniorHandlingFileResults, data, token);


    yield put(getJuniorHandlingFileResultsSuccess(response.data));
  } catch (error) {
    yield put(getJuniorHandlingFileResultsFail(error.response));
  }
}

function* onAddJuniorHandlingEvent({ payload: data, token, navigate }) {


  try {
    const response = yield call(addJuniorHandlingEventResultDisplay, data, token);


    yield put(addJuniorHandlingEventSuccess(response.data));
  } catch (error) {
    yield put(addJuniorHandlingEventFailure(error.response));
  }
}

function* onGetJuniorHandlingEvents({ payload: token }) {


  try {
    const response = yield call(getJuniorHandlingResultsDisplayFiles, token);


    yield put(getJuniorHandlingEventsSuccess(response.data));
  } catch (error) {

    yield put(getJuniorHandlingEventsFail(error.response));
  }
}

function* onGetJuniorHandlingEventsAttendees({ payload: token }) {


  try {
    const response = yield call(getJuniorHandlingFileResultsAttendeesList, token);


    yield put(getJuniorHandlingAttendeeResultsSuccess(response.data));
  } catch (error) {

    yield put(getJuniorHandlingAttendeeResultsFail(error.response));
  }
}


function* onDelJuniorHandlingFile({ payload: data, navigate, token }) {


  try {
    const response = yield call(delJuniorHandlingEventDisplayFile, data, token);

    //toast(response.message);

    yield put(delJuniorHandlingEventFileSuccess(response.data));
  } catch (error) {
    toast(error.response.data.data);
    yield put(delJuniorHandlingEventFileFailure(error.response));
  }
}









function* EventResultsDisplaySaga() {

  yield takeLatest(GET_JUNIOR_HANDLING_RESULT_FILES, onGetJuniorHandlingEvents);
  yield takeLatest(ADD_JUNIOR_HANDLING_EVENT_FILE, onAddJuniorHandlingEvent);
  yield takeLatest(DEL_JUNIOR_HANDLING_DISPLAY_EVENT_FILE, onDelJuniorHandlingFile);
  yield takeLatest(GET_JUNIOR_HANDLING_FILE_RESULTS, onGetJuniorHandlingFileResults);
  yield takeLatest(GET_JUNIOR_EVENT_ATTENDEE_RESULTS,onGetJuniorHandlingEventsAttendees)


}

export default EventResultsDisplaySaga;
